import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import CardDetailPage from './pages/CardDetailPage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 登录页 - 公开访问 */}
        <Route path="/login" element={<LoginPage />} />

        {/* 首页 - 需要登录 */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />

        {/* 卡片详情页 - 需要登录 */}
        <Route
          path="/card/:id"
          element={
            <ProtectedRoute>
              <CardDetailPage />
            </ProtectedRoute>
          }
        />

        {/* 其他路由重定向到首页 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
